import Cookies from 'js-cookie';
import MinProduct from '../Product/MinProduct';
import { CustomVariantItemProps, MinProductItemProps, ProductOurPickItemProps } from "./constants"
import { motion } from 'framer-motion';
import { motionVariants } from '../Common/GlobalVars';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';

import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css";


interface RelatedProductProps {
  our_pick: Array<ProductOurPickItemProps>;
  setSelectProduct: (product: MinProductItemProps) => void;
  selectedCustomVariant: CustomVariantItemProps | null;
  setSelectedCustomVariant: (variant: CustomVariantItemProps | null) => void;
  fromName: string;
  setFromName: (value: string) => void;
  toName: string;
  setToName: (value: string) => void;
  toEmail: string;
  setToEmail: (value: string) => void;
  toMobile: string;
  setToMobile: (value: string) => void;
  toMessage: string;
  setToMessage: (value: string) => void;
  pregnancy: string;
  setPregnancy: (value: string) => void;
  duDate: Date | null;
  setDuDate: (value: Date | null) => void;
  childName: string;
  setChildName: (value: string) => void;
  childAge: number | null;
  setChildAge: (value: number | null) => void;
  childGender: string;
  setChildGender: (value: string) => void;
}

const RelatedProduct = (props: RelatedProductProps) => {
  const { our_pick } = props;
  const viewport = Cookies.get('viewport');

  if (our_pick[0].product_list.length === 0) {
    return (<></>)
  }

  return (
    <>
      <motion.h5
        className="mb-4 text-sm font-bold text-black md:text-base font-poppins md:mb-6 mx-7 md:mx-0"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true }}
        variants={motionVariants}
      >
        Sản phẩm liên quan
      </motion.h5>
      <Swiper
        slidesPerView={viewport === "desktop" ? process.env.NEXT_PUBLIC_STYLE_OPTION === "A" ? 5 : 2.4 : 2.2}
        spaceBetween={16}
        // centeredSlides={viewport === "desktop" ? false : true}
        modules={[Pagination, Navigation]}
        speed={700}
        navigation={viewport === "desktop" ? true : false}
        className="!pb-4 !pl-6 md:!pl-0"
      >
        {our_pick[0].product_list.map((product, index) => (
          <SwiperSlide key={index}>
            <MinProduct
              attribute_value_list={product.attribute_value_list}
              brand={product.brand}
              cash_back={product.cash_back}
              id={product.id}
              cart_image={product.cart_image}
              image={product.image}
              name={product.name}
              product_discount_percent={product.product_discount_percent}
              product_label_bottom_left_category_page={product.product_label_bottom_left_category_page}
              product_label_bottom_right_category_page={product.product_label_bottom_right_category_page}
              product_label_left_product_page={product.product_label_left_product_page}
              product_label_right_product_page={product.product_label_right_product_page}
              msrp={product.msrp}
              qty={product.qty}
              sales_price={product.sales_price}
              sku={product.sku}
              slug={product.slug}
              special_price={product.special_price}
              type={product.type}
              url={product.url}
              product_variant_list={product.product_variant_list}
              attrId={null}
              customName={null}
              setSelectProduct={props.setSelectProduct}
              virtual_product={product.virtual_product}
              need_shipping={product.need_shipping}
              custom_variant_list={product.custom_variant_list}
              selectedCustomVariant={props.selectedCustomVariant}
              setSelectedCustomVariant={props.setSelectedCustomVariant}
              fromName={props.fromName}
              setFromName={props.setFromName}
              toName={props.toName}
              setToName={props.setToName}
              toEmail={props.toEmail}
              setToEmail={props.setToEmail}
              toMobile={props.toMobile}
              setToMobile={props.setToMobile}
              toMessage={props.toMessage}
              setToMessage={props.setToMessage}
              pregnancy={props.pregnancy}
              setPregnancy={props.setPregnancy}
              duDate={props.duDate}
              setDuDate={props.setDuDate}
              childName={props.childName}
              setChildName={props.setChildName}
              childAge={props.childAge}
              setChildAge={props.setChildAge}
              childGender={props.childGender}
              setChildGender={props.setChildGender}
              pwp_name={product.pwp_name}
              pwp={product.pwp}
              key={index}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  )
}

export default RelatedProduct
